import {Component, OnInit} from '@angular/core';
import {DeclineReasonService} from 'src/app/services';

@Component({
    selector: 'app-members-delete',
    templateUrl: './decline-reason.component.html'
})
export class DeclineReasonComponent implements OnInit {
    declineReasons: any;
    ready = false;

    constructor(public declineReasonService: DeclineReasonService) {
    }

    ngOnInit() {
        this.declineReasonService.getDeclineReasons().subscribe(declineReasons => {
            this.declineReasons = declineReasons;
            this.ready = true;
        });
    }
}
